import { Button, ButtonProps } from "@mui/material";

interface GGButtonProps extends ButtonProps{
    btnColor?: string
    disableClickShrink?: boolean;
    roundShape?: boolean;
}

const buttonDefaultProps: GGButtonProps = {
    variant: 'outlined'
};

const GGButton = (props: GGButtonProps) => {
  const { btnColor, disableClickShrink, roundShape, ...rest } = props;
  return (
    <Button
      disableElevation
      {...buttonDefaultProps}
      {...rest}
      sx={{
        color: btnColor || "inherit",
        textTransform: "none",
        letterSpacing: "0px",
        transform: disableClickShrink ? "none !important" : "",
        borderColor: "inherit",
        borderRadius: roundShape ? "500px" : "",
        ":hover": {
          opacity: 1,
          borderColor: "inherit",
          backgroundColor: btnColor ? `${btnColor}08` : "transparent",
          color: btnColor || "inherit",
        },
        ...rest.sx, // allow overriding styles via props
      }}
    >
      {rest.children ? rest.children : "Button"}
    </Button>
  );
};

export default GGButton;
